import React from "react";
import BowlingPinSpinner from "./BowlingPinSpinner";

// Loading Spinner - Now uses bowling pin by default
export const LoadingSpinner = ({
  size = "md",
  className = "",
  variant = "bowling-pin",
}) => {
  if (variant === "bowling-pin") {
    return <BowlingPinSpinner size={size} className={className} />;
  }

  // Legacy circular spinner
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };

  return (
    <div
      className={`${sizeClasses[size]} border-2 border-brand-mist border-t-brand-gold rounded-full animate-spin ${className}`}
    />
  );
};

export default LoadingSpinner;
